module.exports = __webpack_public_path__ + "img/lk-letter.32b35127.svg";